import ApiService from '@/services/api.service'

const BuildingService = {
    getAll(parameter){
        const requestData = {
            method: 'get',
            url: "/Buildings/",       
            params: {
              SearchCriteria: parameter.SearchCriteria,
              PageSize: parameter.PageSize,
              PageNumber: parameter.PageNumber,  
            }
          }       
          return ApiService.customRequest(requestData);
    }, 
    Add(data){
        return ApiService.post(`/Buildings`, data);
    },
    Delete(Id){      
        return ApiService.delete(`/Buildings/${Id}`);
    },
    Update(Id,data){
        return ApiService.put(`/Buildings/${Id}`,data);
    },   
    Get(Id){     
        return ApiService.get(`/Buildings/${Id}`);
    },
    getBuildingsByCode(parameter){
      const requestData = {
        method: 'get',
        url: "/Buildings/",
        headers: {
        },
        params: {          
          code: parameter.code           
        }
      }     
      return ApiService.customRequest(requestData);       
    },
    getLocations(parameter){
        const requestData = {
            method: 'get',
            url: "/Buildings/Locations",       
            params: {
              SearchCriteria: parameter.SearchCriteria,
              PageSize: parameter.PageSize,
              PageNumber: parameter.PageNumber,  
            }
          }       
          return ApiService.customRequest(requestData);
    }, 
    getPharmacies(code){
        const requestData = {
            method: 'get',
            url: "/Buildings/Pharmacies",       
            params: {
              Code: code,  
            }
          }       
          return ApiService.customRequest(requestData);
    }, 
    updatePharmacies(Id,data){
        return ApiService.put(`/Buildings/Pharmacies/${Id}`,data);
    }, 
    getBuildingsLookup(parameter){
      const requestData = {
          method: 'get',
          url: "/Buildings/LookUp",
          headers: {
          },
          params: parameter
      }     
      return ApiService.customRequest(requestData);       
    },
  }


  
  export default BuildingService;